// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Content__Wrapper_1Gm8I container"};